export enum TriggerType {
  STATIC = 0,
  DYNAMIC = 1,
  UNTIL_CHANGE = 2
}
